import * as React from 'react'
import { Button, Form } from 'react-bootstrap'
import CogsLineItem from './CogsLineItem'

import { parseFloatTotal } from '../Job'
import { CogsLineItemT, ExpenseLineItemT, FinancialT, JobT, RevenueLineItemT, TypeFinancialT } from '../../../../types/Job'

import { copyObject } from '../../../../utils'
import * as _ from 'lodash'
import moment from 'moment'

import { getJobDuration } from '../JobUtils'
import { CogsLineItemObj, FinancialObj } from '../InitObjectJob'


export interface ICogsListProps {
    financial: FinancialT
    job: JobT
    addLineItem(lineItemType: TypeFinancialT): void
    updateFinancial(key: string, value: any): void
    sumTotal(lineItems: Array<CogsLineItemT | ExpenseLineItemT | RevenueLineItemT>): number

}

const CogsList: React.FC<ICogsListProps> = ({ job, financial, updateFinancial, sumTotal, addLineItem }) => {
    const [cogs, setCogs] = React.useState(FinancialObj.cogs);
    const [lineItems, setLineItems] = React.useState([]);
    const jobDuration = React.useMemo(() => getJobDuration(job), [job])
    // const [isReady, setIsReady] = React.useState(false);
    // React.useEffect(() => {
    //     setIsReady(true)
    // }, []);
    React.useEffect(() => {
        // console.log("financial->cogs",financial.cogs)
        if (!_.isEqual(financial.cogs, cogs)) {
            setCogs(financial.cogs)
        }
    }, [financial.cogs]);


    // const addLineItem = () => {
    //     let cloneCogs = copyObject(cogs)
    //     let lineItems = copyObject(cloneCogs.lineItems);
    //     let cloneItem = copyObject(CogsLineItemObj)
    //     cloneItem.item = "packingLabor"
    //     lineItems.push(cloneItem)
    //     // cloneCogs.isDirty = true
    //     cloneCogs.lineItems = lineItems
    //     setCogs(cloneCogs)
    //     updateFinancial('cogs', cloneCogs)
    // }


    const updateLineItem = (index: number, lineItem: CogsLineItemT): void => {
        let cloneCogs = copyObject(cogs)

        cloneCogs.lineItems[index] = lineItem
        setCogs(cloneCogs)
        updateFinancial('cogs', cloneCogs)
    }


    const removeLineItem = (index: number) => {
        let cloneCogs = copyObject(cogs)
        let lineItems = copyObject(cloneCogs.lineItems);
        const filteredItems = lineItems.slice(0, index).concat(lineItems.slice(index + 1, lineItems.length))
        if (filteredItems.length <= 0) {
            let item = copyObject(CogsLineItemObj)
            filteredItems.push(item)
        }
        cloneCogs.isDirty = true
        cloneCogs.lineItems = filteredItems;
        setCogs(cloneCogs)
        updateFinancial('cogs', cloneCogs)

    }
    if (!cogs) {
        return null;
    }
    const cogsItems = cogs && cogs.lineItems ? copyObject(cogs.lineItems) : []
    return (
        <>
            <h4>Cost of Goods Sold</h4>
            {_.isArray(cogs?.lineItems) && cogs?.lineItems.map((lineItem: CogsLineItemT, index: number): JSX.Element => {
                return (
                    <CogsLineItem
                        key={index}
                        job={job}
                        jobDuration={jobDuration}
                        cogsLineItem={lineItem}
                        index={index}
                        removeLineItem={removeLineItem}
                        updateLineItem={updateLineItem} />
                )
            })}
            <span style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr 1fr 1fr 1fr 0.1fr' }}>
                <span>
                    <Button
                        onClick={(): void => { addLineItem("cogs") }}
                        variant='light'>
                        Add Line Item
                    </Button>
                </span>
                <span></span>
                <span></span>
                <span></span>
                <span>
                    <Form.Label><strong>Total, $</strong></Form.Label>
                    <Form.Control
                        className='input-material'
                        disabled
                        value={`${parseFloatTotal(sumTotal(cogsItems))}`} />
                </span>
            </span>
        </>
    );
}

export default CogsList;
export { CogsList };